import React, { useEffect, useState } from 'react';

export default function Ticker() {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('/api/notifications', {
      headers: {
        'Client-ID': 'lokanatya_client',
        'Client-Secret': 'super_secret_key_123',
        'Accept': 'application/json'
      }
    })
      .then(res => res.json())
      .then(data => {
        if (data.status === 'success' && data.data) {
          // Limit to 2 notifications
          setNotifications(data.data.slice(0, 2));
        }
      })
      .catch(err => console.error("Failed to fetch ticker notifications:", err))
      .finally(() => setLoading(false));
  }, []);

  const defaultMessage = "Welcome to the new Lokanatya! Browse and book your favorite shows online instantly...";
  let message = defaultMessage;
  
  if (loading) {
    message = "Loading latest updates...";
  } else if (notifications.length > 0) {
    message = notifications.map(n => `${n.title} - ${n.message}`).join('   •   ');
  }

  return (
    <div className="max-w-7xl mx-auto px-0 sm:px-6 lg:px-8 relative z-30 mt-2 md:-mt-6">
      <div className="bg-white rounded-none md:rounded-full shadow-xs md:shadow-md flex items-center p-1 md:p-1.5 pl-1 md:pl-2 relative border-y md:border border-gray-100 overflow-hidden text-sm">
        <div className="bg-[#ef2b2d] text-white font-bold px-3 md:px-4 py-1.5 rounded-full md:rounded-full flex items-center shadow-sm shrink-0 z-10">
           <span className="w-1.5 h-1.5 bg-white rounded-full mr-1.5 md:mr-2 animate-pulse"></span>
           <span className="hidden sm:inline">Latest Updates</span>
           <span className="sm:hidden text-xs">Updates</span>
        </div>
        
        <div className="flex-1 overflow-hidden px-2 md:px-4 flex items-center whitespace-nowrap min-w-0">
           <span className="hidden md:inline text-[#3b82f6] text-[10px] font-bold tracking-widest mr-3 shrink-0">ANNOUNCEMENT <span className="text-gray-300 ml-2">•</span></span>
           <marquee className="text-gray-500 font-medium text-xs md:text-sm" scrollamount="4">{message}</marquee>
        </div>
        
        <div className="hidden md:flex items-center space-x-3 shrink-0 ml-2 md:ml-4 pr-1">
           <div className="flex items-center text-[#3b82f6] text-xs font-bold bg-blue-50 px-3 py-1.5 rounded-full">
              New Show Added <span className="ml-2 text-red-500 text-lg leading-none">🔊</span>
           </div>
           <button className="text-[#ef2b2d] bg-red-50 hover:bg-red-100 text-[10px] font-bold px-4 py-2 rounded-full transition-colors uppercase tracking-wider flex items-center">
              View All <span className="ml-1 text-sm font-normal">&rsaquo;</span>
           </button>
        </div>
      </div>
    </div>
  );
}
